// extracted by mini-css-extract-plugin
export default {"container":"Header_container__u7fbE","headerContainer":"Header_headerContainer__CYFEz","backButton":"Header_backButton__jboA9","title":"Header_title__y+vuq"};